import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

import { useStyles } from "./styles";
import { Snackbar } from '@material-ui/core';

export default function TransitionAlerts(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(props.errors.open);
  const [errors] = React.useState(props.errors.error);
  const handleCloseAlertaGeneral = (event, reason) => {
    if (reason === "clickaway") {
        return;
    }
    props.setErrors({error: [], open: false})
    setOpen(false);
};  

  return (
    <div className={classes.root}>
            <Snackbar open={open} onClose={handleCloseAlertaGeneral}>
                <Alert severity="warning" elevation={6} onClose={handleCloseAlertaGeneral}>
                  <AlertTitle>Datos requeridos sin información</AlertTitle>
                  {
                      errors.map((errors) =>(
                      <div>{errors.name}</div>
                  ))}
                </Alert>
            </Snackbar>
    </div>
  );
}